import Pristine from 'pristinejs';
import updateDonationHeaderCTA from '../modules/donation-links';
import AbandonmentTracking from '../modules/abandonment-tracking';

document.addEventListener('alpine:init', () => {
  Alpine.data('donationsBanner', (
    isPuppyPals,
    donationPage,
    postID,
    donationfrequency,
  ) => {
    let form = null;
    let $form = null;
    let pristine = null;

    return {
      activeIndex: 0,
      errors: {},
      isPuppyPals,
      donationType: isPuppyPals ? 'Monthly' : donationfrequency,
      donationBy: 'individual',
      donationAmount: null,
      donationAmountOther: null,
      donationPage: new URL(donationPage),
      postID,
      _errorMsg: '',
      _msg: '',

      initFunc() {
        form = document.getElementById('donationsBanner');
        $form = $(form);
        new AbandonmentTracking($form, 'banner-donate-next');

        pristine = new Pristine(form);

        const alpineThis = this;

        const donateValueOther = document.querySelector('[name="other-amount"]');

        pristine.addValidator(
          donateValueOther,
          (val) => {
            const frequency = $('[name="donate-frequency"]:checked').val();
            return !(frequency !== 'One-off' && val < 10);
          },
          'The minimum amount for monthly donations is $10.',
          5,
          false,
        );

        pristine.addValidator(
          donateValueOther,
          (val) => {
            const frequency = $('[name="donate-frequency"]:checked').val();
            return !(frequency === 'One-off' && val <= 0);
          },
          'Please enter an amount more than 0.',
          5,
          false,
        );

        updateDonationHeaderCTA($form, null, 'donationsBanner', false);

        this.setPreSelectedDonationAmount(alpineThis);

        $('[name="donate-frequency"]').on('change', () => {
          alpineThis.setPreSelectedDonationAmount(alpineThis);
        });

        $('[name="donate-value"]').on('change', function () {
          const other = $('[name="other-amount"]');

          alpineThis.donationAmount = $(this).val();

          alpineThis.donationAmountOther = null;

          other.val('');
        });

        $('[name="other-amount"]').on('input', () => {
          const donateValue = $('[name="donate-value"]').not('[value="other"]');

          donateValue.each(function () {
            $(this).prop('checked', false);
          });
        });
      },

      setPreSelectedDonationAmount(alpineThis) {
        if (!isPuppyPals) {
          alpineThis.donationType = $('[name="donate-frequency"]:checked').val();
        }

        const preSelectedHandle = $(
          `[data-js-conditional-value=${alpineThis.donationType}] [checked]`,
        );

        preSelectedHandle.prop('checked', true); // Required for case where One-off and Monthly values are preselected
        alpineThis.donationAmount = preSelectedHandle.val();
        alpineThis.donationAmountOther = null;
      },
      error(errorMessage, errorObject = null) {
        this._errorMsg = errorMessage;
        if (errorObject) {
          console.error(errorObject);
        }
      },
      message(message) {
        this._msg = message;
      },
      submit() {
        if (this.validateForm() === false) {
          this.scrollTop();
          return;
        }

        this.donationPage.searchParams.append('donationType', this.donationType);
        this.donationPage.searchParams.append(
          'donationAmount',
          this.donationAmount,
        );
        this.donationPage.searchParams.append(
          'donationAmountOther',
          this.donationAmountOther,
        );
        this.donationPage.searchParams.append('dfrom', this.postID);
        this.donationPage.searchParams.append('step', 2);

        window.location.href = this.donationPage.toString();
      },
      scrollTop() {
        $('html, body').animate(
          {
            scrollTop: $form.offset().top - $('#header').outerHeight(),
          },
          150,
        );
      },
      validateForm() {
        // Reset errors initially.
        this.errors = {};
        this.error('');
        this.message('');

        // Grab all visible elements on the current step.
        const $currentStepElements = $(
          'input:not(:hidden), select:not(:hidden), texarea:not(:hidden)',
          '.donate-form__step.is-active',
        );

        const valid = pristine.validate($currentStepElements);

        // Go through each of the elements and find out if they have errors.
        $currentStepElements.each((i, el) => {
          const individualErrors = pristine.getErrors(el);

          if (individualErrors && individualErrors.length) {
            this.errors[el.getAttribute('name')] = individualErrors[0];
          }
        });

        return valid;
      },
    };
  });
});
